// @ts-check
import React from "react"
import SelectAttribute from "../../SelectAttribute"
import WithActions from "data/wrappers/WithActions"
import RenderRowAttribute from "../../RenderRowAttribute"

/**
 * @type {AttributeItem}
 */
export const selectFormAction = (attributeProps, renderedElementProps = {}) => (
    <RenderRowAttribute
        {...attributeProps}
        render={props => (
            <WithActions>
                {({ actions }) => (
                    <SelectAttribute
                        {...props}
                        options={actions.map(action => ({
                            value: action._sid,
                            label: action.description,
                        }))}
                        {...renderedElementProps}
                    />
                )}
            </WithActions>
        )}
    />
)



// WEBPACK FOOTER //
// ./src/features/editor/attributes/items/actions/formActions.js